import {
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
	RadioGroup,
	RadioGroupItem,
} from "@dune/ui";
import { useSkipDialog } from "../hooks/useSkipDialog";

interface SkipDialogsProps {
	entityId: string;
	isSkipped: boolean;
	canBeSkipped?: boolean;
	onSuccess?: () => void;
}

export const SkipDialogs: React.FC<SkipDialogsProps> = ({
	entityId,
	isSkipped,
	canBeSkipped = true,
	onSuccess,
}) => {
	const {
		skipReason,
		setSkipReason,
		isSkipDialogOpen,
		setIsSkipDialogOpen,
		isUnskipDialogOpen,
		setIsUnskipDialogOpen,
		handleSkipConstruction,
		handleUnskipConstruction,
		handleSkipDialogClose,
		handleUnskipDialogClose,
		isPending,
	} = useSkipDialog(entityId, onSuccess);

	if (isSkipped) {
		return (
			<Dialog open={isUnskipDialogOpen} onOpenChange={setIsUnskipDialogOpen}>
				<DialogTrigger asChild>
					<Button variant="outline">Remettre en cours</Button>
				</DialogTrigger>
				<DialogContent className="sm:max-w-md">
					<DialogHeader>
						<DialogTitle>Remettre le chantier en cours</DialogTitle>
						<DialogDescription>
							Êtes-vous sûr de vouloir remettre ce chantier en cours ? Il
							redeviendra disponible pour soumission.
						</DialogDescription>
					</DialogHeader>

					<div className="grid grid-cols-2 gap-3">
						<Button
							variant="outline"
							className="w-full"
							onClick={handleUnskipDialogClose}
						>
							Annuler
						</Button>
						<Button
							variant="default"
							className="w-full"
							onClick={handleUnskipConstruction}
							isLoading={isPending}
						>
							Remettre en cours
						</Button>
					</div>
				</DialogContent>
			</Dialog>
		);
	}

	if (!canBeSkipped) {
		return null;
	}

	return (
		<Dialog open={isSkipDialogOpen} onOpenChange={setIsSkipDialogOpen}>
			<DialogTrigger asChild>
				<Button variant="outline">Passer le chantier sans suite</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Passer le chantier sans suite</DialogTitle>
					<DialogDescription>
						Merci de sélectionner la raison :
					</DialogDescription>
				</DialogHeader>

				<RadioGroup value={skipReason} onValueChange={setSkipReason}>
					<div className="flex items-center space-x-2">
						<RadioGroupItem
							value="placed_elsewhere"
							id="placed_elsewhere"
							label="J'ai placé l'affaire ailleurs"
						/>
					</div>
					<div className="flex items-center space-x-2">
						<RadioGroupItem
							value="not_realized"
							id="not_realized"
							label="Je n'ai pas réalisé l'affaire"
						/>
					</div>
				</RadioGroup>

				<div className="grid grid-cols-2 gap-3">
					<Button
						variant="outline"
						className="w-full"
						onClick={handleSkipDialogClose}
					>
						Annuler
					</Button>
					<Button
						variant="default"
						className="w-full"
						onClick={handleSkipConstruction}
						disabled={!skipReason}
						isLoading={isPending}
					>
						Passer sans suite
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};
